export const musicPlay = ({commit}) => {
    commit('musicPlay')
}

export const musicMute = ({commit}) => {
    commit('musicMute')
}

export const propModal = ({commit}, met) => {
    commit('propModal', met)
}

export const game = ({commit}, func) => {
    commit('game', func)
}
